module.exports = __webpack_public_path__ + "img/stq.899670d5.svg";